import { useForm } from '../../context/FormContext'
import FormField from '../ui/FormField'
import Select from '../ui/Select'
import Button from '../ui/Button'
import ar from '../../locales/ar.json'

const t  = ar.step4
const ta = ar.app

const ROLE_OPTIONS = Object.keys(t.witnessRoles).map((v) => ({ value: v, label: v }))

function WitnessCard({ witness, index, onChange, onRemove, errors }) {
  const err = (k) => errors[`witness_${k}_${index}`]
  return (
    <div className="p-4 border border-stone-200 rounded-xl bg-stone-50 relative mb-4">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-sm font-semibold text-primary-700">{t.witnessNumber} {index + 1}</h3>
        <button
          type="button"
          onClick={onRemove}
          className="text-red-500 hover:text-red-700 text-sm"
          aria-label={`حذف الشاهد ${index + 1}`}
        >
          ✕ حذف
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FormField id={`wname_${index}`} label={t.witness_name} required error={err('name')}>
          <input
            id={`wname_${index}`}
            type="text"
            value={witness.witness_name}
            onChange={(e) => onChange('witness_name', e.target.value)}
            className="input-base"
            dir="rtl"
          />
        </FormField>
        <FormField id={`wphone_${index}`} label={t.witness_phone} error={err('phone')}>
          <input
            id={`wphone_${index}`}
            type="tel"
            value={witness.witness_phone}
            onChange={(e) => onChange('witness_phone', e.target.value)}
            className="input-base"
            dir="ltr"
            style={{ textAlign: 'right' }}
          />
        </FormField>
      </div>

      <Select
        id={`wrole_${index}`}
        label={t.witness_role}
        required
        value={witness.witness_role}
        onChange={(v) => onChange('witness_role', v)}
        options={ROLE_OPTIONS}
        placeholder={ta.select}
        error={err('role')}
      />

      <Select
        id={`wconsent_${index}`}
        label={t.witness_contact_consent}
        value={witness.witness_contact_consent}
        onChange={(v) => onChange('witness_contact_consent', v)}
        options={[{ value: 'نعم', label: ta.yes }, { value: 'لا', label: ta.no }]}
        placeholder={ta.select}
      />

      <FormField id={`wnotes_${index}`} label={t.witness_notes}>
        <textarea
          id={`wnotes_${index}`}
          value={witness.witness_notes}
          onChange={(e) => onChange('witness_notes', e.target.value)}
          className="input-base"
          rows={3}
          dir="rtl"
        />
      </FormField>
    </div>
  )
}

export default function Step4_Witnesses() {
  const { state, updateField, addWitness, updateWitness, removeWitness } = useForm()
  const { formData, errors } = state

  const hasWitnesses = formData.has_witnesses === 'نعم'

  return (
    <div>
      <h2 className="section-title">
        <span className="bg-primary-700 text-white w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">٤</span>
        {t.sectionTitle}
      </h2>

      {/* Has witnesses */}
      <div className="mb-4">
        <label className="label-base" htmlFor="has_witnesses">
          {t.has_witnesses}
          <span className="text-red-500 mr-1">*</span>
        </label>
        <div className="flex gap-4 mt-1">
          {[{ v: 'نعم', l: ta.yes }, { v: 'لا', l: ta.no }, { v: 'غير متأكد', l: ta.notSure }].map(({ v, l }) => (
            <label key={v} className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="has_witnesses"
                value={v}
                checked={formData.has_witnesses === v}
                onChange={() => updateField('has_witnesses', v)}
                className="w-4 h-4 text-primary-700"
              />
              <span className="text-sm text-stone-700">{l}</span>
            </label>
          ))}
        </div>
        {errors.has_witnesses && (
          <p className="mt-1 text-xs text-red-600" role="alert">{errors.has_witnesses}</p>
        )}
      </div>

      {/* Witness list */}
      {hasWitnesses && (
        <div className="mt-4">
          {formData.witnesses.map((w, i) => (
            <WitnessCard
              key={i}
              witness={w}
              index={i}
              onChange={(field, val) => updateWitness(i, field, val)}
              onRemove={() => removeWitness(i)}
              errors={errors}
            />
          ))}

          {formData.witnesses.length < 5 ? (
            <Button variant="secondary" size="sm" onClick={addWitness} type="button">
              + {t.addWitness}
            </Button>
          ) : (
            <p className="text-sm text-stone-400">{t.maxWitnesses}</p>
          )}
        </div>
      )}
    </div>
  )
}
